module.exports = __webpack_public_path__ + "static/media/中高図書委員会.4adc54d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/exhibition/中高図書委員会.png
// module id = 311
// module chunks = 10